import { useEffect } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { useBienContext } from '../BienContext'

import { PlusIcon } from '@heroicons/react/24/outline'
import DetailTemplate from '@/components/DetailTemplate'
import { FilterButton, Pagination } from '@/components/ui'
import { 
  cancelNewPrestataireCreation, 
  emptyIntervention, 
  fetchInterventions, 
  InterventionStatuses, 
  InterventionStatusFilters, 
  resetInterventionInEdition, 
  setFilters,
  setInterventionInEdition
} from '../../interventions/interventionsSlice'
import Form from '../../interventions/form/Form'
import InterventionItem from '../../interventions/Intervention'


const InterventionsDetail = () => {
  const dispatch = useDispatch()
  const { bien, updatedSections, markSectionAsUpdated } = useBienContext()
  const interventions = useSelector(state => state.interventions.items)
  const filters = useSelector((state) => state.interventions.filters)
  const pagination = useSelector((state) => state.interventions.pagination)
  const isLoading = useSelector( state => state.interventions.loadingStatus.fetchList )

  const isCreatingNewPrestataire = useSelector( state => state.interventions.isCreatingNewPrestataire)

  const SECTION_ID = 'interventions'
  const SECTION_TITLE = 'Historique des interventions'

  useEffect(
    () => {
      dispatch(setFilters({statut: 'in_progress'}))
    },
    []
  )

  useEffect(
    () => {
      if(bien?.id) {
        dispatch(fetchInterventions({bien_id: bien.id, ...filters}))
      }
    },
    [ bien.id, filters.statut ]
  )

  useEffect(() => {
    if(filters.page != pagination.currentPage) {
      const queryFilters = { ...filters, bien_id: bien.id}
      dispatch(fetchInterventions(queryFilters))
    }
  }, [dispatch, filters])

  const handlePageChange = (page) => {
    dispatch(setFilters({ page }))
  }  

  const statutFilterCheckboxes = InterventionStatusFilters.map( 
    statut => ({
      ...statut,
      checked: statut.value === filters.statut
    })
  )

  const AddNewInterventionButton = ({onEditClick}) => {
  
    const handleClick = async (event) => {
      event.preventDefault()
      event.stopPropagation()
      dispatch(setInterventionInEdition(emptyIntervention))
      onEditClick()
    }

    const handleFiltersChange = (newFilters) => {
      dispatch(setFilters({statut: newFilters.statut}))
    }
  
    return (
      <div>
        <div className="dropdown">
          <FilterButton 
              filters={statutFilterCheckboxes} 
              onChange={handleFiltersChange}
              defaultCheckedFilter="in_progress"
          />
        </div>
        <button 
          className="btn btn-sm btn-primary"
          title="Ajouter une nouvelle intervention au bien"
          onClick={handleClick}
        >
          <PlusIcon className="h-5 w-5 mr-1"/> Ajouter une intervention
        </button>
      </div>
    )
  }

  const closeModalCallback = () => {
    if(isCreatingNewPrestataire) {
      dispatch(cancelNewPrestataireCreation())
    }
    dispatch(resetInterventionInEdition())
  }

  return (
    <DetailTemplate
      sectionId={SECTION_ID}
      title={SECTION_TITLE}
      bodyProps={{columns: 1, bgColor: 'white', className: 'p-0'}}
      updatedSections={updatedSections}
      loading={isLoading}
      isPendingAction={isLoading}
      editButton={<AddNewInterventionButton />}
      modalContent={<Form />}
      onUpdateSuccess={markSectionAsUpdated}
      onCloseModalCallback={closeModalCallback}
    >
      <div>
        { interventions?.length > 0 && (
          <>
          { interventions.map((intervention, index) =>(
            <InterventionItem key={index} item={intervention}/>
          ))}
          </>
        )}
        { interventions?.length == 0 && (
          <div className='bg-gray-100 p-4'>
            <p>Aucune intervention</p>
          </div>
        )}
        { pagination.totalPages > 1 && (
          <Pagination
            currentPage={pagination.currentPage}
            totalPages={pagination.totalPages}
            onPageChange={handlePageChange}
          />
        )}
      </div>
    </DetailTemplate>
  )
}

export default InterventionsDetail